import { UserRoles } from "data/roles";
import { userConverter } from "db/converters";
import { subscribeToDocument } from "db/subscriptions";
import { COLLECTION_NAME } from "services/users";
import { useState, useEffect } from "react";

/**
 * Hook para obtener los datos del usuario actual.
 * @param {string} uid - ID del usuario.
 * @returns {object} Objeto con los datos del usuario, su rol y permisos.
 */
export const useUserManager = (userId) => {
  const [isLoading, setLoading] = useState(true);
  const [profile, setProfile] = useState({});
  const [permissions, setPermissions] = useState([]);
  const [role, setRole] = useState(null);

  useEffect(() => {
    if (!userId) {
      setProfile({});
      setPermissions([]);
      setRole(null);
      setLoading(false);
      return;
    }

    // Se inicia la carga de datos del usuario
    setLoading(true);

    // Se suscribe a los datos del usuario en tiempo real
    const unsubscribeUser = subscribeToDocument(
      COLLECTION_NAME,
      userId,
      (data) => {
        const { role, permissions, ...profile } = data || {};
        setProfile(profile || {});
        setPermissions(permissions || []);
        setRole(role === UserRoles.ADMIN ? UserRoles.ADMIN : UserRoles.USER);
        setLoading(false);
      },
      userConverter
    );

    // Se limpia la suscripción cuando el usuario cambia o cierra sesión
    return () => unsubscribeUser();
  }, [userId]);

  return { profile, role, permissions, isLoading };
};
